import React, { useEffect, useState, Fragment, useRef } from "react";
import { PageHeader } from '../../../../Common';
import services from "../service";
import authService from "../../../Common/services";
import { LoadingSpinerComponent } from "../../../../Common/loader";
import { trackPromise } from "react-promise-tracker";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import { DailyFieldPerformanceReportSchemaObject } from "../DailyFieldPerformanceReportSchema";
import { validateProperty, validate } from "../../../Common";
import tokenService from "../../../../Common/tokenDecoder";
import ReactToPrint from "react-to-print";
import CreatePdf from './createPdf';
import '../../../Common/Table/table.css';
import xlsx from 'json-as-xlsx';
import './printScale.css';
import _ from 'lodash';
import { makeStyles } from '@material-ui/core/styles';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import Paper from '@material-ui/core/Paper';
import { TableRow } from "@material-ui/core";
import { Card } from '@material-ui/core';
import { Container } from '@material-ui/core';

const screenCode = "DAILYFIELDPERFORMANCEREPORT";

const useStyles = makeStyles({
    table: {
        minWidth: 650,
    },
    dialog1: {
        width: 850,
    }
});

export function DailyFieldPerformance(props) {

    const componentRef = useRef();
    const classes = useStyles();
    const [groups, setGroups] = useState([]);
    const [estates, setEstates] = useState([]);
    const [multipleEstates, setMultipleEstates] = useState([]); 
    const [divisions, setDivisions] = useState([]);
    const [fields, setFields] = useState();
    const [isTableHide, setIsTableHide] = useState(true);
    const [limit, setLimit] = useState(10);
    const [page, setPage] = useState(0);
    const [numOfDays, setNumOfDays] = useState([]);
    const [allTotal, setAllTotal] = useState(0);
    const [headings, setHeadings] = useState([]);
    const [startdayName, setStartdayName] = useState([]);

    const [dailyFieldPerformance, setDailyFieldPerformance] = useState({
        groupID: 0,
        estateID: "0",
        divisionID: "0",
        fieldID: "0",
        month: ""

    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: 0,
        estate: "0",
        division: "0",
        field: "0",
        month: ""
    })

    const [errors, setErrors] = useState({});

    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false,
    });

    const [isReportButtonsEnabled, setIsReportButtonsEnabled] = useState(false);
    const [buttonHide, setButtonHide] = useState(true);
    const [reportData, setReportData] = useState([]);
    const [totalArray, setTotalArray] = useState([]);

    useEffect(() => {
        trackPromise(getPermissions());
    }, []);

    useEffect(() => {
        trackPromise(
            getEstatesForDropdown(),
        )
    }, [dailyFieldPerformance.groupID])

    useEffect(() => {
        trackPromise(
            getDivisionsForDropDown(),
        )
    }, [dailyFieldPerformance.estateID])

    useEffect(() => {
        if (dailyFieldPerformance.divisionID > 0) {
            trackPromise(
                getFeildsByCollectionPoint(),
            )
        }
    }, [dailyFieldPerformance.divisionID]);


    function clearTable() {
        setIsTableHide(true);
        setIsReportButtonsEnabled(false);
        setReportData([]);
        setDailyFieldPerformance({
            groupID: 0,
            estateID: "0",
            divisionID: "0",
            fieldID: "0",
            month: ""
        })
    }

    function handleGroupChange(target) {
        validateInputs(target);
        setDailyFieldPerformance({
            ...dailyFieldPerformance,
            groupID: target.value,
            estateID: "0",
            divisionID: "0",
            fieldID: "0",
        });
    }

    function handleEstateChange(target) {
        validateInputs(target);
        setDailyFieldPerformance({
            ...dailyFieldPerformance,
            estateID: target.value,
            divisionID: "0",
            fieldID: "0"
        });
    }

    function handleDivisionChange(target) {
        validateInputs(target);
        setDailyFieldPerformance({
            ...dailyFieldPerformance,
            divisionID: target.value,
            fieldID: "0"
        });
    }

    function handleFieldChange(target) {
        validateInputs(target);
        setDailyFieldPerformance({
            ...dailyFieldPerformance,
            fieldID: target.value
        });
    }

    function handleSearchDateChange(target) {
        validateInputs(target);
        setDailyFieldPerformance({
            ...dailyFieldPerformance,
            month: target.value
        });
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, DailyFieldPerformanceReportSchemaObject);
        errorMessage
            ? (error[target.name] = errorMessage)
            : delete error[target.name];
        setErrors(error);
    }

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWDAILYFIELDPERFORMANCEREPORT');
        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined,
        });

        var token = tokenService.getUserDetailsFromTokenV2();

        if (token.operationEntities.length > 0) {

            var estateArray = [];
            for (let item of Object.entries(token.operationEntities)) {
                estateArray[item[1]["OperationEntityID"]] = item[1]["OperationEntityName"]
            }

            setMultipleEstates(estateArray)

            setDailyFieldPerformance({
                ...dailyFieldPerformance,
                groupID: token.groupID
            });

        } else {
            setDailyFieldPerformance({
                ...dailyFieldPerformance,
                groupID: token.groupID,
                estateID: token.operationEntityID
            });
        }

        setDailyFieldPerformance({
            ...dailyFieldPerformance,
            groupID: token.groupID,
            estateID: token.operationEntityID
        });
        trackPromise(getGroupsForDropdown());
    }

    async function getGroupsForDropdown() {
        const result = await services.getAlGroupsForDropdown();
        setGroups(result);
    }

    async function getEstatesForDropdown() {
        const result = await services.GetAllOperationEntityByGroupID(dailyFieldPerformance.groupID);
        setEstates(result);
    }

    async function getDivisionsForDropDown() {
        const data = await services.getDivisionByEstateID(dailyFieldPerformance.estateID);
        setDivisions(data);
    }

    async function getFeildsByCollectionPoint() {
        const fields = await services.GetAvialableFieldsForDropdown(dailyFieldPerformance.divisionID);
        setFields(fields);
    }

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(
                    <MenuItem key={key} value={key}>
                        {value}
                    </MenuItem>
                );
            }
        }
        return items;
    }

    async function getdata(e) {
        e.preventDefault();
        setIsTableHide(true);
        setButtonHide(true);
        getSelectedDropdownValuesForReport(dailyFieldPerformance);
        setIsTableHide(true);

        var model = {
            groupID: parseInt(dailyFieldPerformance.groupID),
            estateID: parseInt(dailyFieldPerformance.estateID),
            divisionID: parseInt(dailyFieldPerformance.divisionID),
            fieldID: parseInt(dailyFieldPerformance.fieldID),
            month: dailyFieldPerformance.month
        }
        const res = await services.DailyFieldPerformanceReportData(model);
        let monthValue = model.month;

        const month = monthValue.split('-')[1];

        const year = monthValue.split('-')[0];

        function getDaysInMonth(year, month) {
            return new Date(year, month, 0).getDate();
        }
        const value = getDaysInMonth(year, month);

        const date = new Date(monthValue + '-01');
        const dayOfWeek = date.toLocaleDateString('en-US', { weekday: 'short' });

        const daysNamesArray = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

        let daysArray = [];

        const elementIndex = daysNamesArray.indexOf(dayOfWeek);

        for (let i = 0; i < value; i++) {

            for (let j = 0; j < daysNamesArray.length; j++) {
                if (daysArray.length < (value + elementIndex)) {
                    daysArray.push(daysNamesArray[j]);
                }
                else { break; }
            }

        }
        const newDaysArray = daysArray.slice(elementIndex);
        const csvHeaders = [];

        csvHeaders.push({ label: "Field Name", value: "fieldName" })
        let dateArray = [];
        for (let i = 0; i < value; i++) {
            var dayLength = ((i + 1).toString()).length
            dateArray.push((dayLength == 1 ? ('0' + (i + 1)).toString() : (i + 1).toString()).toString())
            csvHeaders.push({ label: ('day ' + (i + 1)).toString(), value: (dayLength == 1 ? ('0' + (i + 1)).toString() : (i + 1).toString()).toString() })
        }
        csvHeaders.push({ label: "Total", value: "amount" })
        let newRes = _.cloneDeep(res);

        var result = [];
        var totalArray = [];
        totalArray.push({ name: "fieldName", value: "Total" });
        var totalOfAllrecords = 0;
        newRes.forEach(z => {
            z.groupedData.forEach(x => {

                const date = x.cardReadTime.split('T')[0];
                const day = date.split('-')[2];
                var duplicateDate = result.find(y => y.fieldID === x.fieldID);

                var duplicateTotalRowData = totalArray.find(y => parseInt(y.name) === parseInt(day));

                if (duplicateTotalRowData) {
                    duplicateTotalRowData.value = duplicateTotalRowData.value == undefined ?
                        0 + x.actualAmount : duplicateTotalRowData.value + x.actualAmount;
                }
                else {
                    totalArray.push({
                        name: day,
                        value: x.actualAmount
                    });
                }

                if (duplicateDate) {
                    duplicateDate[day] = duplicateDate[day] == undefined ?
                        0 + x.actualAmount : duplicateDate[day] + x.actualAmount;
                    duplicateDate.division = x.division;
                    duplicateDate.estateName = x.estateName;
                    duplicateDate.fieldName = x.fieldName;
                    duplicateDate.fieldID = x.fieldID;
                    duplicateDate.amount = duplicateDate.amount == undefined ?
                        0 + x.actualAmount : duplicateDate.amount + x.actualAmount;
                    totalOfAllrecords = totalOfAllrecords + x.actualAmount;
                }
                else {
                    result.push({
                        [day]: x.actualAmount,
                        division: x.division,
                        estateName: x.estateName,
                        fieldName: x.fieldName,
                        fieldID: x.fieldID,
                        amount: x.actualAmount
                    });
                    totalOfAllrecords = totalOfAllrecords + x.actualAmount;
                }
            });

        });
        totalArray.push({ name: "amount", value: totalOfAllrecords });
        setAllTotal(totalOfAllrecords);
        setTotalArray(totalArray);
        setHeadings(csvHeaders)
        setReportData(result);
        setNumOfDays(dateArray);
        setStartdayName(newDaysArray);

        if (result.length > 0) {
            setIsTableHide(false);
            setIsReportButtonsEnabled(true);
        } else {
            setIsReportButtonsEnabled(false);
        }
        setButtonHide(false);
        setIsReportButtonsEnabled();
    }

    function createFile() {
        var settings = {
            sheetName: ' DP report',
            fileName: 'DP Report',
            writeOptions: {}
        }

        var copyOfCsv = [...reportData]
        let newAllTotal = _.cloneDeep(totalArray);

        const obj = newAllTotal.reduce((acc, cur) => {
            acc[cur.name] = cur.value;
            return acc;
        }, {});

        var newRow1 = {
            fieldName: "Group :" + groups[dailyFieldPerformance.groupID]
        }

        var newRow2 = {
            fieldName: "Estate : " + estates[dailyFieldPerformance.estateID]
        }

        var newRow3 = {
            fieldName: "Division : " + divisions[dailyFieldPerformance.divisionID]
        }

        var newRow4 = {
            fieldName: "Field : " + fields[dailyFieldPerformance.fieldID]
        }

        var newRow5 = {
            fieldName: "Month : " + dailyFieldPerformance.month
        }

        copyOfCsv.push(obj, {}, {}, newRow1, newRow2, newRow3, newRow4, newRow5)
        xlsx(headings, copyOfCsv, settings, true)
    }

    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID],
            estate: estates[searchForm.estateID],
            division: divisions[searchForm.divisionID],
            field: fields[searchForm.fieldID],
            month: searchForm.month
        })
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">

                        <PageHeader
                            title="Daily Field Performance Report"
                            isButtonEnable={permissionList.isAddEditEnabled}
                        />
                        <div className="card-body">
                            <form
                                disabled={false}
                            >
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            value={dailyFieldPerformance.groupID}
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            onChange={(e) => handleGroupChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && (
                                            <FormHelperText error>{errors["groupID"]}</FormHelperText>
                                        )}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="estateID"> Estate *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="estateID"
                                            id="estateID"
                                            name="estateID"
                                            value={dailyFieldPerformance.estateID}
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            onChange={(e) => handleEstateChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                            {generateDropDownMenu(multipleEstates.length == 0 ? estates : multipleEstates)}
                                        </Select>
                                        {errors["estateID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["estateID"]}</FormHelperText>)}
                                    </div>

                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="">Division *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="divisionID"
                                            id="divisionID"
                                            name="divisionID"
                                            value={dailyFieldPerformance.divisionID}
                                            onChange={(e) => handleDivisionChange(e.target)}
                                        >
                                            <MenuItem value="0">-- Select Division --</MenuItem>
                                            {generateDropDownMenu(divisions)}
                                        </Select>
                                        {errors["divisionID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["divisionID"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="fieldID">Field</InputLabel>
                                        <Select fullWidth
                                            id="fieldID"
                                            name="fieldID"
                                            value={dailyFieldPerformance.fieldID}
                                            onChange={(e) => handleFieldChange(e.target)}>
                                            <MenuItem value="0">--All Field--</MenuItem>
                                            {generateDropDownMenu(fields)}
                                        </Select>
                                        {errors["fieldID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["fieldID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="month">Month *</InputLabel>
                                        <TextField
                                            fullWidth
                                            placeholder="-- Select Month --"
                                            id="month"
                                            name="month"
                                            type="month"
                                            onChange={(e) => handleSearchDateChange(e.target)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                        {errors["month"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["month"]}</FormHelperText>)}
                                    </div>
                                </div>
                                <div className="card-footer">
                                    <input
                                        type="button"
                                        className="btn btn-primary"
                                        value="Search"
                                        onClick={e => trackPromise(getdata(e))}
                                    />
                                    <input type="reset" className="btn btn-warning pull-right"
                                        value="Cancel"
                                        onClick={clearTable}
                                    />
                                </div>
                                <br />
                                {reportData.length > 0 ?
                                    <div className="form-group row">
                                        <div className="col-md-12 pb-1">
                                            <Container>
                                                <Card style={{ justifycontent: 'center' }}>
                                                    <Paper className={classes.paper}>
                                                        <TableContainer>
                                                            <Table aria-label="simple table">
                                                                <TableHead>
                                                                    <TableRow>
                                                                        <TableCell align="center" style={{ fontWeight: "bold" }}>Field Name</TableCell>

                                                                        {numOfDays.map((count, i) => (
                                                                            <TableCell key={i} align="center" style={{ fontWeight: "bold" }}>{count}</TableCell>
                                                                        ))}

                                                                        <TableCell align="center" style={{ fontWeight: "bold" }}>Total</TableCell>
                                                                    </TableRow>
                                                                    <TableRow>
                                                                        <TableCell align="center" style={{ fontWeight: "bold" }}>  </TableCell>

                                                                        {startdayName.map((count, i) => (
                                                                            <TableCell key={i} align="center" style={{ fontWeight: "bold" }}>{count}</TableCell>
                                                                        ))}
                                                                    </TableRow>
                                                                </TableHead>
                                                                <TableBody>
                                                                    {reportData.map((rows, i) => (
                                                                        <TableRow key={i} >
                                                                            <TableCell component="th" scope="row" align="center"> {rows.fieldName}</TableCell>
                                                                            {numOfDays.map((count) => {
                                                                                const result = rows[count]

                                                                                if (result == undefined) {
                                                                                    return (
                                                                                        <TableCell component="th" scope="row" align="center"> - </TableCell>
                                                                                    );
                                                                                }
                                                                                else {
                                                                                    return (
                                                                                        <TableCell component="th" scope="row" align="center" style={{ backgroundColor: "#1de9b6" }}> {parseFloat(result).toFixed(2)}</TableCell>
                                                                                    );
                                                                                }
                                                                            })}
                                                                            <TableCell component="th" scope="row" style={{ backgroundColor: "#14a37f" }} align="center"> {parseFloat(rows.amount).toFixed(2)}</TableCell>
                                                                        </TableRow>
                                                                    ))}
                                                                    <TableRow>
                                                                        <TableCell component="th" style={{ fontWeight: "bold" }} scope="row" align="center"> Total</TableCell>
                                                                        {numOfDays.map((count) => {
                                                                            const result = totalArray.find(x => x.name == count)

                                                                            if (result == undefined) {
                                                                                return (
                                                                                    <TableCell component="th" style={{ fontWeight: "bold" }} scope="row" align="center"> - </TableCell>
                                                                                );
                                                                            }
                                                                            else {
                                                                                return (
                                                                                    <TableCell component="th" scope="row" align="center" style={{ fontWeight: "bold", backgroundColor: "#14a37f" }}> {parseFloat(result.value).toFixed(2)}</TableCell>
                                                                                );
                                                                            }
                                                                        })}
                                                                        <TableCell component="th" scope="row" style={{ fontWeight: "bold" }} align="center"> {parseFloat(allTotal).toFixed(2)}</TableCell>
                                                                    </TableRow>
                                                                </TableBody>
                                                            </Table>
                                                        </TableContainer>
                                                    </Paper>
                                                </Card>
                                            </Container>
                                        </div>
                                    </div>
                                    : null}
                            </form>
                            {isTableHide ? null :
                                <div>
                                    <br />
                                    <>
                                        <div className="pt-2" justify-content="center" >
                                            <input
                                                type="button"
                                                className="btn btn-primary pull-right ml-2"
                                                value="Excel"
                                                onClick={createFile}
                                            />
                                            <ReactToPrint
                                                documentTitle={"Daily Field Performance Report"}
                                                trigger={() => <input
                                                    type="submit"
                                                    className="btn btn-primary pull-right ml-2"
                                                    value="PDF"
                                                />}
                                                content={() => componentRef.current}
                                            />
                                        </div>
                                        <div hidden={true}>
                                            <CreatePdf ref={componentRef} data={reportData}
                                                allTotal={allTotal} totalArray={totalArray}
                                                searchData={selectedSearchValues} daysCount={numOfDays}
                                                startDay={startdayName} />
                                        </div>
                                    </>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}
